import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OtpVerifyComponent } from './otp-verify/otp-verify.component';
import { EmailOtpVerifyComponent } from './email-otp-verify/email-otp-verify.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component'
import { RedirectComponent } from './redirect/redirect.component';
import { RewardsComponent } from './rewards/rewards.component';
import { VerifyContactWarningComponent } from './verify-contact-warning/verify-contact-warning.component';

const routes: Routes = [
  { path: 'otp-verify', component: OtpVerifyComponent, },
  { path: 'otp-verify/:username', component: OtpVerifyComponent, },
  { path: 'Profile/:account_setting/ChangePhoneNumber/:username/OtpVerify', component: OtpVerifyComponent, },
  { path: 'sign-in', component: SignInComponent, },
  { path: ':sign_in_type/sign-in', component: SignInComponent, },
  { path: 'rewards', component: RewardsComponent },
  { path: 'Profile/:sign_in_type/SignIn', component: SignInComponent, },
  { path: 'forget-password', component: ForgetPasswordComponent, },
  { path: 'resetPassword/:token', component: ResetPasswordComponent, },
  { path: 'reset_password/:username/:token', component: ResetPasswordComponent, },
 

  { path: 'Profile/AccountSetting/ChangePassword', component: ChangePasswordComponent, },
  { path: 'enrollment-in-process', component: RedirectComponent, },
  { path: 'verify-contact-warning', component: VerifyContactWarningComponent, },
  // { path: 'email/verify/:account_setting/:raw_id/:token', component: EmailOtpVerifyComponent, },
  // { path: 'email/verify/:raw_id/:token', component: EmailOtpVerifyComponent, },
  { path: 'email/verify/:account_setting/:raw_id', component: EmailOtpVerifyComponent, },
  { path: 'email/verify/:raw_id', component: EmailOtpVerifyComponent, },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/auth/auth-routing.module.ts